import styled from "styled-components";

export const Error = styled.p`
  font-size: ${({ theme }) => theme.fontSize.s};
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  width: 100%;
  margin: 0;
  color: ${({ theme }) => theme.colors.red};
`;
